var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: "1.98px",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M97.92 19.8h47.31v120.67H15.09V19.8h58.54"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: "1.7px",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M23.87 111.86h48.55l-4.26 18.25h22.58l-4.26-18.25h48.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4 121.89a2 2 0 0 1-3.9 0c0-1.07.87-5.39 2-5.39s1.9 4.32 1.9 5.39Z",
    style: {
      fill: "#1d1d1b",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 121.9c.12-9.11.23-18.22.28-27.33l.2-27.34c.06-4.55 0-9.11.2-13.71a108.65 108.65 0 0 1 1.45-13.69 73.75 73.75 0 0 1 3.55-13.34 49.88 49.88 0 0 1 2.86-6.33c.56-1 1.16-2 1.82-3a19.5 19.5 0 0 1 2.28-2.81.88.88 0 0 1 1.24 1.25l-.05.05a18.18 18.18 0 0 0-2 2.48A31.77 31.77 0 0 0 88.06 21a43.56 43.56 0 0 0-2.8 6.09 72.22 72.22 0 0 0-3.42 13 108.6 108.6 0 0 0-1.39 13.51c-.2 4.51-.08 9.07-.06 13.63l.2 27.34c0 9.11.16 18.22.28 27.33a1.42 1.42 0 1 1-2.84 0Z",
    style: {
      fill: "#1d1d1b"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair);
export default __webpack_public_path__ + "static/media/hair.5bf9de1a.svg";
export { ForwardRef as ReactComponent };